var map = {
	"./NightDrive.svg": 4812,
	"./Phonk.jpg": 5180,
	"./Phonk.png": 328,
	"./Phonk.svg": 408,
	"./default-tag.svg": 6242,
	"./hiphop.svg": 2774,
	"./rap.svg": 4675,
	"./ukrainian.png": 6204,
	"./ukrainian.svg": 9768
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1943;